import { useLocalization } from "../../hooks/useLocalization";

export const Introduction = () => {
  const { strings } = useLocalization();
  const imgs = import.meta.env.VITE_S3_ASSET_URL;

  const paragraphClass =
    "m-0 mb-4 text-start font-jetbrains text-base text-white/[0.88] max-[600px]:mb-4";

  return (
    <section className="relative w-screen min-h-[80vh] overflow-hidden pt-44 mx-[calc(50%-50vw)] max-[600px]:min-h-[auto] max-[600px]:pt-36 max-[600px]:pb-8">
      <div className="about-page-shell relative z-[1] flex min-h-[calc(80vh-11rem)] items-center max-[600px]:min-h-[auto]">
        <div className="w-[min(100%,36rem)] max-w-[52%] max-[900px]:max-w-[58%] max-[600px]:w-full max-[600px]:max-w-full">
          <h1 className="mb-4 text-start font-morganite text-[clamp(4rem,10vw,8rem)] font-bold leading-[0.72] tracking-[0.04em] uppercase max-[600px]:mt-32">
            {strings.ABOUT.INTRODUCTION.TITLE}
          </h1>
          <p className={paragraphClass} style={{ lineHeight: 1.65 }}>
            {strings.ABOUT.INTRODUCTION.PARAGRAPH.ONE}
          </p>
          <p className={paragraphClass} style={{ lineHeight: 1.65 }}>
            {strings.ABOUT.INTRODUCTION.PARAGRAPH.TWO}
          </p>
          <p className={paragraphClass} style={{ lineHeight: 1.65 }}>
            {strings.ABOUT.INTRODUCTION.PARAGRAPH.THREE}
          </p>
        </div>
      </div>
      <img
        className="pointer-events-none absolute top-0 right-0 z-0 h-full w-1/2 object-cover object-center [mask-image:linear-gradient(to_right,transparent_0%,black_18%)] [-webkit-mask-image:linear-gradient(to_right,transparent_0%,black_18%)] max-[900px]:w-[55%] max-[600px]:top-0 max-[600px]:left-0 max-[600px]:right-auto max-[600px]:h-[150vh] max-[600px]:w-full max-[600px]:opacity-20 max-[600px]:[mask-image:none] max-[600px]:[-webkit-mask-image:none]"
        src={`${imgs}/images/introduction-img.jpg`}
        loading="lazy"
        decoding="async"
        width={960}
        height={1200}
        alt="A user seated by a computer playing"
      />
    </section>
  );
};
